/* can be used to sort Columns 

Params:
prevVal and nextVal
*/

// eslint-disable-next-line import/prefer-default-export
export const sortColumnValues = (prevVal: any, nextVal: any) => {
  let prev: any = prevVal
  let next: any = nextVal
  // force null and undefined to the bottom
  prev = prev === null || prev === undefined ? -Infinity : prev
  next = next === null || next === undefined ? -Infinity : next
  // force any string values to lowercase
  prev = typeof prev === 'string' ? prev.toLowerCase() : prev
  next = typeof next === 'string' ? next.toLowerCase() : next
  // Return either 1 or -1 to indicate a sort priority
  if (prev > next) {
    return 1
  }
  if (prev < next) {
    return -1
  }
  // returning 0, undefined or any falsey value will use subsequent sorts or the index as a tiebreaker
  return 0
}
